export default __webpack_public_path__ + "static/logo-f52078ea4c42dd0b22d0fed1d3511f95.png";